export default __webpack_public_path__ + "static/media/testimonial-header.58405670.png";